import React from 'react';
import ContactForm from '../components/ContactForm';

const Contact = ({ formSubmitted, setFormSubmitted }) => {
  return (
    <div className="contact-page">
      <section className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with our team for inquiries and consultations</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info">
              <h2>Let's Work Together</h2>
              <p>We're here to help you elevate your electromechanical systems with our smart solutions. Contact us for any inquiries or to schedule a consultation.</p>
              
              <div className="contact-details">
                <h3>Contact Information</h3>
                <p><strong>📍 Address:</strong> UAE Silicon Oasis Digital Park Freezone, DUBAI</p>
                <p><strong>📞 Phone:</strong> (+971) 563002576</p>
                <p><strong>✉️ Email:</strong> info.taqnya@gmail.com</p>
                <p><strong>🏢 Company:</strong> TAQNYA FZCO</p>
              </div>
              
              <div className="contact-details">
                <h3>Business Hours</h3>
                <p><strong>Sunday - Thursday:</strong> 8:00 AM - 6:00 PM</p>
                <p><strong>Friday:</strong> Closed</p>
                <p><strong>Saturday:</strong> 9:00 AM - 1:00 PM</p>
              </div>
              
              <div className="contact-details">
                <h3>Our Commitment</h3>
                <p>We strive to respond to all inquiries within 24 hours during business days. Your satisfaction is our priority.</p>
              </div>
            </div>
            
            <div className="contact-form-side">
              <ContactForm formSubmitted={formSubmitted} setFormSubmitted={setFormSubmitted} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;